<template>
  <KTTable
    title="Fuente Modificación"
    subtitle="Lista de Fuente Modificación"
    :fields="fields"
    :items="$store.state.fuenteMod.fuentesMod"
    @delete="deleteItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_FUENTE_MOD } from "@/core/services/store/fuenteMod.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "Id Fuente Mod",
          sortable: true
        },
        {
          key: "codigo",
          label: "Código Fuente Modificación",
          sortable: true
        },
        {
          key: "literal",
          label: "Lieral Fuente Modificación",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    deleteItem(item) {
      this.$store.commit(DELETE_FUENTE_MOD, item);
    }
  }
};
</script>
